import React, { Component } from 'react';
import Lottie from 'react-lottie';

import travel from '../../../assets/animations/travel.json';

import './AboutUs.css';

class AboutUs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      width : window.innerWidth || document.documentElement.clientWidth,
      height : window.innerHeight|| document.documentElement.clientHeight,
      isStopped: false,
      isPaused: false
    }
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: travel,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
    const { height, width } = this.state;
    return (
      <section className="about-us">
        <div className="common-StripeGrid">
          <div className="backgroundContainer">
            <div className="grid">
              <div className="background"></div>
            </div>
          </div>
          <div className="stripeContainer">
            <div className="grid">
              <span className="stripe s3 green3"></span>
              <span className="stripe s5 green3"></span>
            </div>
          </div>
        </div>
        <div className="row container-lg">
          <div className="col-12 col-md-8">
            <h2>
              Quienos Somos<br/>
              <span>y cómo trabajamos</span>
            </h2>
            <div className="text">
              <p>TotalParts Corp es una compañía estadounidense especialista en exportaciones coorporativas a diferentes partes del mundo.</p>
              <p><strong>Usaproductos</strong> surge debido a la necesidad de un servicio minorista con atención personalizada a clientes que deseen comprar productos en Internet. ¿El funcionamiento? Sencillo. Comprás, lo envías a nuestras oficinas de Estados Unidos y lo recibis en Buenos Aires en 72 horas.</p>
            </div>
          </div>
          <div className="animation col-12 col-md-4">
            <Lottie options={defaultOptions}
             height={width > 400 ? 380 : width-40}
             width={width > 400 ? 380 : width-40}
             isStopped={this.state.isStopped}
             isPaused={this.state.isPaused}
            />
          </div>
        </div>
      </section>
    )
  }
}

export default AboutUs;



// WEBPACK FOOTER //
// ./src/components/Home/AboutUs/AboutUs.js